var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderNoir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 974 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M956.24 0H0v789h870.285C1174.38 378.5 685.674 380.464 956.24 0z",
    fill: "#000",
    fillOpacity: 0.3
  })));
}

export default __webpack_public_path__ + "da359a7c18b884fc1e02405aff64df1d.svg";
export { SvgHeaderNoir as ReactComponent };